// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios/index.js';
import './style/animate.min.css';
import app from './nmb/app';
import rely from './nmb/oauth2/oauth2rely';
import clientConfig from './params/config';
import oauth2 from './params/oauth2';
import './assets/font/iconfont.css';
import './assets/font2/iconfont.css';
import './assets/font3/iconfont.css';
import './assets/font4/iconfont.css';
import './assets/font5/iconfont.css';
import Icon from 'vue2-svg-icon/Icon.vue';

Vue.use(ElementUI);
Vue.component('icon', Icon);
Vue.config.productionTip = false;
app.params = Object.assign(app.params, clientConfig);

// rely.defaultParams = Object.assign(rely.defaultParams, oauth2);

router.beforeEach((to, from, next) => {
  //产品门户跳转新站
  if (to.fullPath.indexOf('upgrade') > -1) {
    window.location.href = clientConfig.upgradeHost
  }
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});
router.afterEach((to, from) => {
  if (!!document.querySelector('.layout-box')) {
    (document.querySelector('.layout-box') as any).scrollTop = 0;
  }
});
// tslint:disable-next-line:no-unused-expression
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
  beforeCreate() {
    Vue.prototype.bus = this;
  }
});
